import type { MailboxInfo } from 'owa-client-types';
import { isMessageRecallEnabled as isMessageRecallEnabledInTenant } from 'owa-nonboot-userconfiguration-manager';

export default function isMessageRecallEnabled(mailboxInfo: MailboxInfo) {
    return isMessageRecallEnabledInTenant(mailboxInfo);
}
